import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { SFStack, SFTypography, SFButton, SFIcons } from "@sf-core";
import { getJobDetails } from "../../services/profileService";
import DetailsDialog from "../dialog/detailsDialog";
import { useNavigate } from "react-router-dom";
import { getJobUrl } from "../../constants/urls";

const JobDetailsDialog = ({ dialog, setDialog }) => {
  const [jobDetails, setJobDetails] = useState(null);
  const [badges, setBadges] = useState([]);
  const [skills, setSkills] = useState(null);
  const { t } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    getJobDetails(dialog.jobId).then((jobResponse) => {
      setJobDetails(jobResponse.data);
      const jobSkills = jobResponse.data.successProfileSkills.map((skill) => ({
        id: skill.skillId,
        name: skill.skillName,
        rank: skill.skillRank,
      }));
      setSkills(jobSkills.sort((a, b) => a.rank - b.rank));
      setBadges([
        {
          label: t("profileScreen.detailsDialog.businessCapabilityLabel"),
          description: jobResponse.data.businessCapabilityName,
        },
        {
          label: t("profileScreen.detailsDialog.disciplineLabel"),
          description: jobResponse.data.disciplineName,
        },
        {
          label: t("profileScreen.detailsDialog.jobFamilyLabel"),
          description: jobResponse.data.jobFamilyName,
          ignoreIcon: true,
        },
      ]);
    });
  }, []);

  return (
    <DetailsDialog
      open={dialog.open && jobDetails !== null}
      setDialog={setDialog}
      header={jobDetails?.jobName}
      description={jobDetails?.jobDescription}
      titleThumbnail={jobDetails?.thumbnail}
      badges={badges}
      skills={skills}
      skillsTitle={t("jobDetailsDialog.label")}
      actionsBoxShadow
      actionBtns={
        <SFStack direction="row" alignItems="center" spacing={2}>
          <SFButton
            variant="transparent"
            onClick={() => setDialog({ open: false })}
          >
            <SFTypography>{t("jobDetailsDialog.closeBtn")}</SFTypography>
          </SFButton>
          <SFButton
            variant="secondary"
            onClick={() => {
              navigate(getJobUrl(dialog.domainId));
              setDialog({ open: false });
            }}
            startIcon={<SFIcons.SFPlayIcon />}
          >
            <SFTypography>{t("jobDetailsDialog.viewJobBtn")}</SFTypography>
          </SFButton>
        </SFStack>
      }
    />
  );
};

export default JobDetailsDialog;
